export enum ApiEventType {
    NightVersionAnalyzed = "night-version-analyzed",
}
